import Vue from 'vue'
import hui from 'hui'
import './style/hui-reset.scss'
import './style/index.scss'
import './style/common.scss'
import initLogin from './loginPage/initLogin'
// 引入storage读取库
import storage from 'good-storage'
import moment from 'moment'
import lodash from 'lodash'
import echarts from 'echarts'
Vue.use(hui)

Vue.prototype.$moment = moment
// 引入lodash用来做深拷贝
Vue.prototype.$lodash = lodash
Vue.prototype.$echarts = echarts
// 将jsencrypt压入到Vue
// Vue.prototype.$jsEncrypt = JsEncrypt
// 将stroage压入Vue
Vue.prototype.$storage = storage

initLogin(Vue)
